import React, {useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroller";
import {useDispatch, useSelector} from "react-redux";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumbs from "../../../components/breadcrumbs";
import Button from "../../../components/button";
import Input from "../../../components/input";
import ItemList1 from "../../../components/item-list-1";
import Search from "../../../components/search";
import SelectInput from "../../../components/select";
import TextArea from "../../../components/text-area";
import {
    clear_maintenance,
    CREATE_MAINTENANCE,
    createMaintenance,
    getAllMaintenance,
    get_report,
    GET_REPORT,
    getItemMaintenance, 
    updateMaintenance, 
    UPDATE_MAINTENANCE
} from '../../../redux/maintenance';
import Select from "react-select";
import LoadingSpinner from "../../../components/loading-spinner";
import {getAllTypeMaintenance} from "../../../redux/type_maintenance";
import Card from "../../../components/card";
import Modal from "../../../components/modal";
import {get_status, URLAPI} from "../../../config";
import {getAllReasonMaintenance} from "../../../redux/reason_maintenance";
import {get_all_companies} from "../../../redux/company";
import {get_all_zones} from "../../../redux/zones";
import CheckBox from "../../../components/check-box";
import {getAllSuppliers} from "../../../redux/supplier";
import {
    clear_maintenance_survey_results,
    CREATE_MAINTENANCE_SURVEY_RESULTS,
    createMaintenanceSurveyResults,
} from "../../../redux/maintenance_survey_results";
import {getAllCategoryMaintenance} from "../../../redux/categories_maintenances";


const MaintenanceAdmin = (props) => {
    const dispatch = useDispatch();

    const _get_all_maintenance = useSelector((state) => state.maintenance_module._get_all_maintenance);

    const _get_all_type_maintenance = useSelector((state) => state.type_maintenance_module._get_all_type_maintenance);
    const _get_all_category_maintenance = useSelector((state) => state.category_maintenance_module._get_all_category_maintenance);
    const _get_all_reason_maintenance = useSelector((state) => state.reason_maintenance_module._get_all_reason_maintenance);
    const _create_maintenance_survey_results = useSelector((state) => state.maintenance_survey_results_module._create_maintenance_survey_results);

    const _create_maintenance = useSelector((state) => state.maintenance_module._create_maintenance);
    const _update_maintenance = useSelector((state) => state.maintenance_module._update_maintenance);
    const _get_all_companies = useSelector((state) => state.company_module._get_all_companies);
    const _get_all_zones = useSelector((state) => state.zone_module._get_all_zones);
    const _get_all_supplier = useSelector((state) => state.supplier_module._get_all_suppliers);

    const _get_report = useSelector((store) => store.maintenance_module._get_report);
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    useEffect(() => {
        dispatch(getAllMaintenance(token));
        // eslint-disable-next-line
    }, [token, dispatch]);

    const userEstablishmentsList = useSelector(
        (state) => state.users_module._session_data.data
    );

    const [showDetail, setShowDetail] = useState(false);
    const [showSibarLeft, setShowSibarLeft] = useState(false);
    const [showSibarRight, setShowSibarRight] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [establishment, setEstablishment] = useState([]);
    const [typeMaintenance, setTypeMaintenance] = useState([]);
    const [reasonMaintenance, setReasonMaintenance] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [zones, setZones] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [surveys, setSurveys] = useState([]);
    const [categories, setCategories] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        let array = []
        if (userEstablishmentsList) {
            if (userEstablishmentsList.establecimientos) {
                array = userEstablishmentsList.establecimientos.map(element => {
                    return {
                        value: element.id,
                        label: element.nombre + ' (' + element.codigo + ')',
                    }
                })
            }
        }
        setEstablishment(array)
    }, [userEstablishmentsList])


    useEffect(() => {
        if (_get_all_category_maintenance && _get_all_category_maintenance.data && _get_all_category_maintenance.data.datos) {
            let array = [];
            // eslint-disable-next-line
            _get_all_category_maintenance.data.datos.map(x => {
                if (x.activo === true) {
                    array.push({
                        value: x.id,
                        label: x.descripcion
                    })
                }
            });
            setCategories(array);
        }
    }, [_get_all_category_maintenance]);

    useEffect(() => {
        if (_get_all_type_maintenance && _get_all_type_maintenance.data && _get_all_type_maintenance.data.datos) {
            let array = [];
            // eslint-disable-next-line
            _get_all_type_maintenance.data.datos.map(x => {
                if (x.activo === true) {
                    array.push({
                        value: x.id,
                        label: x.descripcion
                    })
                }
            });
            setTypeMaintenance(array);
        }
    }, [_get_all_type_maintenance]);

    useEffect(() => {
        if (_get_all_reason_maintenance && _get_all_reason_maintenance.data && _get_all_reason_maintenance.data.datos) {
            let array = _get_all_reason_maintenance.data.datos.filter(x => x.activo === true);
            setReasonMaintenance(array);
        }
    }, [_get_all_reason_maintenance]);

    useEffect(() => {
        if (_get_all_supplier && _get_all_supplier.data && _get_all_supplier.data.datos) {
            let array = _get_all_supplier.data.datos.filter(x => x.activo === true);
            setSuppliers(array);
        }
    }, [_get_all_supplier]);

    useEffect(() => {
        if (_get_all_companies && _get_all_companies.data && _get_all_companies.data.datos) {
            let array = [];
            // eslint-disable-next-line
            _get_all_companies.data.datos.map(x => {
                if (x.activo === true) {
                    array.push({
                        value: x.id,
                        label: x.nombre
                    })
                }
            });
            setCompanies(array);
        }
    }, [_get_all_companies]);

    useEffect(() => {
        if (_get_all_zones && _get_all_zones.data && _get_all_zones.data.datos) {
            let array = [];
            // eslint-disable-next-line
            _get_all_zones.data.datos.map(x => {
                if (x.activo === true) {
                    array.push({
                        value: x.id,
                        label: x.nombre
                    })
                }
            });
            setZones(array);
        }
    }, [_get_all_zones]);

    /* Creating an array of objects. */
    const filter_options = [
        {name: 'Rango de fechas', id: 1},
        {name: 'Empresa', id: 2},
        {name: 'Zona', id: 3},
        {name: 'Establecimiento', id: 4},
        {name: 'Categoría', id: 5},
        {name: 'Tipo', id: 6},
    ];

    const [range_date, setRangeDate] = useState({
        visible: false,
        date_start: '',
        date_end: ''
    })

    const [other_filter, setOtherFilter] = useState({
        visible_establishment: false,
        id_establishment: 0,
        visible_company: false,
        id_company: 0,
        visible_zone: false,
        id_zone: 0,
        visible_category: false,
        id_category: 0,
        visible_type: false,
        id_type: 0,
    });

    const [datas, setDatas] = useState([]);
    const [count, setCount] = useState(0);
    const [HasMore, setHasMore] = useState(true);

    // eslint-disable-next-line
    const initForm = {
        id: 0,
        id_establecimiento: 0,
        descripcion: "",
        id_tipo: 0,
        imagen: "",
        presupuesto: false,
    };
    
    // eslint-disable-next-line
    const [form, setForm] = useState(initForm);

    const [permisos, setPermisos] = useState([]);

    useEffect(() => {
        if (_create_maintenance.status === 201) {
            toast.success("Mantenimiento creado correctamente", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            dispatch(clear_maintenance(CREATE_MAINTENANCE));
            dispatch(getAllMaintenance(token, 1));
            setShowSibarRight(false);
            setIsLoading(false);
        } else if (_create_maintenance.status !== 0) {
            toast.error(_create_maintenance.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            setShowSibarRight(false);
            dispatch(clear_maintenance(CREATE_MAINTENANCE));
            setIsLoading(false);
        }
    }, [_create_maintenance, dispatch, initForm, token])

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
        if (_get_all_maintenance && _get_all_maintenance.data && _get_all_maintenance.data.datos) {
            setDatas(_get_all_maintenance.data.datos);
        }

    }, [_get_all_maintenance, count, props]);

    const loadFunc = () => {
        if (_get_all_maintenance.data.datos) {
            if (_get_all_maintenance.data.datos.length > count) {
                const ordenado = _get_all_maintenance.data.datos.sort((a, b) => {
                    return new Date(b.fecha_creacion + ' 00:00:00') - new Date(a.fecha_creacion + ' 00:00:00');
                });
                setDatas([...datas, ...ordenado.slice(count, count + 10)]);
                setCount(count + 10);
            }
            setHasMore(false);
        }
    };

    const filterToday = (e) => {
        setEstablishmentSelectFilter([]);
        setCompanySelectFilter([]);
        setZoneSelectFilter([]);
        setTypeSelectFilter([]);
        setCategorySelectFilter([]);
        if (e.target.value === "0") {
            setDatas(_get_all_maintenance.data.datos);
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
            setOtherFilter({
                visible_establishment: false,
                id_establishment: 0,
                visible_company: false,
                id_company: 0,
                visible_zone: false,
                id_zone: 0,
                visible_category: false,
                id_category: 0,
                visible_type: false,
                id_type: 0,
            });
        }
        if (e.target.value === '1') {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: true
            });
        } else {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
        }
        if (e.target.value === '2' || e.target.value === '3' || e.target.value === '4' || e.target.value === '5' || e.target.value === '6') {
            if (e.target.value === '2') {
                dispatch(get_all_companies(token));
                setOtherFilter({
                    visible_establishment: false,
                    id_establishment: 0,
                    visible_company: true,
                    id_company: 0,
                    visible_zone: false,
                    id_zone: 0,
                    visible_category: false,
                    id_category: 0,
                    visible_type: false,
                    id_type: 0,
                });
            }
            if (e.target.value === '3') {
                dispatch(get_all_zones(token));
                setOtherFilter({
                    visible_establishment: false,
                    id_establishment: 0,
                    visible_company: false,
                    id_company: 0,
                    visible_zone: true,
                    id_zone: 0,
                    visible_category: false,
                    id_category: 0,
                    visible_type: false,
                    id_type: 0,
                });
            }
            if (e.target.value === '4') {
                setOtherFilter({
                    visible_establishment: true,
                    id_establishment: 0,
                    visible_company: false,
                    id_company: 0,
                    visible_zone: false,
                    id_zone: 0,
                    visible_category: false,
                    id_category: 0,
                    visible_type: false,
                    id_type: 0,
                });
            }
            if (e.target.value === '5') {
                dispatch(getAllCategoryMaintenance(token));
                setOtherFilter({
                    visible_establishment: false,
                    id_establishment: 0,
                    visible_company: false,
                    id_company: 0,
                    visible_zone: false,
                    id_zone: 0,
                    visible_category: true,
                    id_category: 0,
                    visible_type: false,
                    id_type: 0,
                });
            }
            if (e.target.value === '6') {
                dispatch(getAllTypeMaintenance(token));
                setOtherFilter({
                    visible_establishment: false,
                    id_establishment: 0,
                    visible_company: false,
                    id_company: 0,
                    visible_zone: false,
                    id_zone: 0,
                    visible_category: false,
                    id_category: 0,
                    visible_type: true,
                    id_type: 0,
                });
            }
        } else {
            setOtherFilter({
                visible_establishment: false,
                id_establishment: 0,
                visible_company: false,
                id_company: 0,
                visible_zone: false,
                id_zone: 0,
                visible_category: false,
                id_category: 0,
                visible_type: false,
                id_type: 0,
            });
        }
    }

    const handleChangePresupuesto = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.checked,
        });
    }

    const handleFileChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.files[0],
        });
    };

    const handleChangeOptions = (e) => {
        let survey = surveys.filter(survey => survey.id === parseInt(e.target.name));
        if (survey.length > 0) {
            survey[0].opcion_id = parseInt(e.target.value);
        }
    };

    const handleChange = (e) => {
        if (e.target.name === "id_establecimiento") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    const [establishment_select, setEstablishmentSelect] = useState([]);

    const handleChangeEstablishment = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_establecimiento']: parseInt(e.value),
        });
        setEstablishmentSelect(e);
    }


    const [type_maintenance_select, setTypeMaintenanceSelect] = useState([]);

    const handleChangeTypeMaintenance = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_tipo']: parseInt(e.value),
        });
        setTypeMaintenanceSelect(e);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (form.id_establecimiento === 0) {
            toast.error("Debe seleccionar el establecimiento");
            setIsLoading(false);
            return;
        }
        if (form.id_tipo === 0) {
            toast.error("Debe seleccionar el tipo de mantenimiento");
            setIsLoading(false);
            return;
        }
        if (form.descripcion === "") {
            toast.error("Debe ingresar una descripción");
            setIsLoading(false);
            return;
        }
        if (form.imagen === "") {
            toast.error("Debe seleccionar una foto");
            setIsLoading(false);
            return;
        }

        dispatch(createMaintenance(token, form))
    }

    const handleSearch = (e) => {
        setIsLoading(true);
        if (e.target.value === "") {
            setDatas(_get_all_maintenance.data.datos);
            setIsLoading(false);
            return;
        }
        setDatas([]);
        let nombre = e.target.value;
        nombre = nombre.trim();
        let re = new RegExp(nombre, "i");
        // eslint-disable-next-line
        let filtro = _get_all_maintenance.data.datos.filter(element => {
            if (element.establecimiento.match(re) != null || element.secuencial.match(re) != null) {
                return element;
            }
        })
        setDatas(filtro);
        setIsLoading(false);
    }

    const handleFilterRangeDate = (e) => {
        if (e.target.name === 'date_start') {
            range_date.date_start = e.target.value
        }
        if (e.target.name === 'date_end') {
            range_date.date_end = e.target.value
        }

        if (range_date.date_start !== '' && range_date.date_end !== '') {
            let date_start = new Date(range_date.date_start + ' 00:00:00');
            let date_end = new Date(range_date.date_end + ' 23:59:59');
            // eslint-disable-next-line
            let final = _get_all_maintenance.data.datos.filter(x => {
                    if (x.fecha_creacion) {
                        let fecha = new Date(x.fecha_creacion);
                        if (fecha.getTime() >= date_start.getTime() && fecha.getTime() <= date_end.getTime()) {
                            return x;
                        }
                    }
                }
            )
            setDatas(final);
        }
    }

    useEffect(() => {
        if (_get_report.status === 200) {
            toast.success(_get_report.data.mensaje);
            dispatch(clear_maintenance(GET_REPORT));
            setIsLoading(false);
        } else if (_get_report.status !== 0) {
            toast.error(_get_report.message);
            dispatch(clear_maintenance(GET_REPORT));
            setIsLoading(false);
        }
    }, [_get_report, dispatch])

    const handleGenerateReport = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(get_report({
            'fecha_inicio': range_date.date_start,
            'fecha_fin': range_date.date_end,
            'id_establecimiento': other_filter.id_establishment,
            'id_empresa': other_filter.id_company,
            'id_zona': other_filter.id_zone,
            'id_tipo': other_filter.id_type,
            'id_categoria': other_filter.id_category,
        }, token));

    }

    const [establishment_select_filter, setEstablishmentSelectFilter] = useState([]);

    const handleChangeEstablishmentFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_establishment': parseInt(e.value),
        });
        let va = _get_all_maintenance.data.datos.filter(x => parseInt(x.id_establecimiento) === parseInt(e.value));
        setDatas(va);
        setEstablishmentSelectFilter(e);
    }

    const [company_select_filter, setCompanySelectFilter] = useState([]);

    const handleChangeCompanyFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_company': parseInt(e.value),
        });
        let va = _get_all_maintenance.data.datos.filter(x => parseInt(x.id_empresa) === parseInt(e.value));
        setDatas(va);
        setCompanySelectFilter(e);
    }

    const [zone_select_filter, setZoneSelectFilter] = useState([]);

    const handleChangeZoneFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_zone': parseInt(e.value),
        });
        let va = _get_all_maintenance.data.datos.filter(x => parseInt(x.id_zona) === parseInt(e.value));
        setDatas(va);
        setZoneSelectFilter(e);
    }

    const [type_select_filter, setTypeSelectFilter] = useState([]);

    const handleChangeTypeFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_type': parseInt(e.value),
        });
        let va = _get_all_maintenance.data.datos.filter(x => parseInt(x.id_tipo) === parseInt(e.value));
        setDatas(va);
        setTypeSelectFilter(e);
    }

    const [category_select_filter, setCategorySelectFilter] = useState([]);

    const handleChangeCategoryFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_category': parseInt(e.value),
        });
        let va = _get_all_maintenance.data.datos.filter(x => parseInt(x.id_categoria) === parseInt(e.value));
        setDatas(va);
        setCategorySelectFilter(e);
    }

    const initSelect = {
        id: 0,
        secuencial: "",
        establecimiento: "",
        codigo_establecimiento: "",
        descripcion: "",
        motivo: "",
        estado: "",
        tipo: "",
        fecha_creacion: "",
        fecha_mantenimiento: "",
        fecha_aprobacion: "",
        image: "",
        valor_inicial: 0,
        valor: 0,
        presupuesto: false,
        encuesta_realizada: false,
        invoice: "",
        proveedor: ""
    };

    const [DataSelected, setDataSelected] = useState(initSelect);
    const [modalAceptar, setModalAceptar] = useState(false);
    const [modalValidar, setModalValidar] = useState(false);
    const [modalDecline, setModalDecline] = useState(false);
    const [modalReschedule, setModalReschedule] = useState(false);
    const [modalSurvey, setModalSurvey] = useState(false);
    const [valueInitial, setValueInitial] = useState(0);
    const [value, setValue] = useState(0);
    const [dateMaintenance, setDateMaintenance] = useState('');
    const [idSupplier, setIdSupplier] = useState(0);
    const [invoice, setInvoice] = useState('');
    const [idReason, setIdReason] = useState(0);

    const onItemClickListener = async (item) => {
        const response = await getItemMaintenance(token, item.id);
        if (response && response.data && response.data.datos) {
            setDataSelected(response.data.datos[0]);
            setSurveys(response.data.encuesta);
            if (response.data.datos[0].encuesta_realizada === false &&
                (response.data.datos[0].estado === "MANTENIMIENTO EJECUTADO" || response.data.datos[0].estado === "MANTENIMIENTO FINALIZADO") &&
                permisos.filter(x => x.codigo === 'add_maintenance').length > 0)
            {
                setModalSurvey(true);
            }
        }
        setShowDetail(true);
    }

    useEffect(() => {
        if (_update_maintenance.status === 200) {
            toast.success(_update_maintenance.data.mensaje);
            dispatch(clear_maintenance(UPDATE_MAINTENANCE));
            // eslint-disable-next-line
            dispatch(getAllMaintenance(token));
            setIsLoading(false);
            setModalValidar(false);
            setModalAceptar(false);
            setModalDecline(false);
            setModalReschedule(false);
            setShowDetail(false);
            if (_update_maintenance.data.survey) {
                setModalSurvey(true);
            }
        } else if (_update_maintenance.status !== 0) {
            toast.error(_update_maintenance.message);
            dispatch(clear_maintenance(UPDATE_MAINTENANCE));
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_maintenance, dispatch])

    const handleSubmitAccept = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(updateMaintenance(token, DataSelected.id, {"estado": "MANTENIMIENTO ACEPTADO"}))
    }

    const handleSubmitExecuted = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(updateMaintenance(token, DataSelected.id, {"estado": "MANTENIMIENTO EJECUTADO"}))
    }

    const handleSubmitApproval = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (valueInitial === 0) {
            toast.error("Debe ingresar en costo inicial del mantenimiento");
            setIsLoading(false);
            return;
        }
        if (!dateMaintenance) {
            toast.error("Debe seleccionar la fecha del mantenimiento");
            setIsLoading(false);
            return;
        }
        if (idSupplier === 0) {
            toast.error("Debe seleccionar el proveedor");
            setIsLoading(false);
            return;
        }
        dispatch(updateMaintenance(token, DataSelected.id, {'valor_inicial': valueInitial, 'fecha': dateMaintenance, 'id_proveedor': idSupplier, 'estado': 'MANTENIMIENTO APROBADO'}));
    }

    const handleUpdateSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (value === 0) {
            toast.error("Debe ingresar el costo real del mantenimiento");
            setIsLoading(false);
            return;
        }
        if (!invoice) {
            toast.error("Debe seleccionar la factura");
            setIsLoading(false);
            return;
        }
        dispatch(updateMaintenance(token, DataSelected.id, {'factura': invoice, 'valor': value, 'estado': 'MANTENIMIENTO FINALIZADO'}));
    }

    const handleDeclineSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (idReason === 0) {
            toast.error("Debe seleccionar un motivo");
            setIsLoading(false);
            return;
        }
        dispatch(updateMaintenance(token, DataSelected.id, {"estado": "MANTENIMIENTO RECHAZADO", "id_motivo": idReason}))
    }

    const handleRescheduleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (dateMaintenance === '') {
            toast.error("Debe seleccionar la nueva fecha del mantenimiento");
            setIsLoading(false);
            return;
        }
        dispatch(updateMaintenance(token, DataSelected.id, {"estado": "MANTENIMIENTO APROBADO", "fecha": dateMaintenance, "reschedule": true}))
    }

    useEffect(() => {
        if (_create_maintenance_survey_results.status === 201) {
            toast.success("Guardado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_maintenance_survey_results(CREATE_MAINTENANCE_SURVEY_RESULTS));
            setIsLoading(false);
            setModalSurvey(false);
            setShowDetail(false);
            if (surveys.length > 0) {
                // eslint-disable-next-line
                surveys.map((x) => {
                    const l = 'opcion-' + x.id;
                    document.getElementById(l).selectedIndex = 0;
                });
            }
        } else if (_create_maintenance_survey_results.status !== 0) {
            dispatch(clear_maintenance_survey_results(CREATE_MAINTENANCE_SURVEY_RESULTS));
            toast.error(_create_maintenance_survey_results.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_maintenance_survey_results, dispatch]);


    const handleSurveySubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let valid = true;
        // eslint-disable-next-line
        surveys.map(x => {
            if (parseInt(x.opcion_id) === 0) {
                toast.error("Debe seleccionar una respuesta para la pregunta: \n " + x.pregunta);
                setIsLoading(false);
                valid = false;
                // eslint-disable-next-line
                return;
            }
        })
        if (valid) {
            let results = [];
            // eslint-disable-next-line
            surveys.map(x => {
                results.push(x.opcion_id);
            })
            dispatch(createMaintenanceSurveyResults(token, {mantenimiento_id: DataSelected.id, resultados: results}))
        }
    }

    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">

                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 ">
                        <Breadcrumbs
                            title="Mantenimientos"
                            items={[{label: "Listado mantenimientos", link: "/mantenimientos"}]}
                            onclick
                        />
                    </div>
                </div>
                <div className="content-body">

                    <div className="content-area-wrapper" style={{margin: 0}}>


                        <div className={`sidebar-left ${showSibarLeft ? 'show' : ''}`}>
                            <div className="sidebar">

                                <div className="sidebar-content email-app-sidebar d-flex">
                                    {/* sidebar close icon */}
                                    <span className="sidebar-close-icon" onClick={
                                        () => {
                                            setShowSibarLeft(false)
                                            setShowOverlay(false)
                                        }
                                    }>
                                        <i className="bx bx-x"/>
                                    </span>
                                    {/* sidebar close icon */}
                                    <div className="email-app-menu">
                                        <div className="form-group form-group-compose">
                                            {/* compose button  */}
                                            {
                                                permisos.filter(element => element.codigo === "add_maintenance").length > 0 &&
                                                <Button
                                                    text="Crear"
                                                    onChange={() => {
                                                        dispatch(getAllTypeMaintenance(token));
                                                        setShowSibarRight(!showSibarRight);
                                                        setShowSibarLeft(false);
                                                        setShowDetail(false);
                                                        setForm(initForm)
                                                        setShowOverlay(!showSibarRight);
                                                        setEstablishmentSelect([]);
                                                        setTypeMaintenanceSelect([]);
                                                    }}
                                                    theme="success"
                                                    classes=" btn-block my-2 compose-btn"
                                                />
                                            }
                                        </div>
                                        <div className="sidebar-menu-list">
                                            {/* sidebar menu  */}
                                            <div className="list-group list-group-messages">
                                                <SelectInput
                                                    id="filtro-maintenancea"
                                                    name="filtro-maintenancea"
                                                    options={filter_options}
                                                    onChange={filterToday}
                                                />
                                                <ul className="list-unstyled mb-0">
                                                    {range_date.visible &&
                                                        <>
                                                            <li className=" mr-2 mb-1">
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Inicio"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_start'

                                                                />
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Fin"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_end'

                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {other_filter.visible_company &&
                                                        <>
                                                            <li className=" mr-2 mb-1">
                                                                <label>Empresa</label>
                                                                <Select
                                                                    options={companies}
                                                                    isMulti={false}
                                                                    onChange={handleChangeCompanyFilter}
                                                                    value={company_select_filter}
                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {other_filter.visible_zone &&
                                                        <>
                                                            <li className=" mr-2 mb-1">
                                                                <label>Zona</label>
                                                                <Select
                                                                    options={zones}
                                                                    isMulti={false}
                                                                    onChange={handleChangeZoneFilter}
                                                                    value={zone_select_filter}
                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {other_filter.visible_establishment &&
                                                        <>
                                                            <li className=" mr-2 mb-1">
                                                                <label className="form-label">Establecimiento</label>
                                                                <Select
                                                                    options={establishment}
                                                                    isMulti={false}
                                                                    onChange={handleChangeEstablishmentFilter}
                                                                    value={establishment_select_filter}
                                                                />

                                                            </li>
                                                        </>
                                                    }
                                                    {other_filter.visible_category &&
                                                        <>
                                                            <li className=" mr-2 mb-1">
                                                                <label className="form-label">Categoría</label>
                                                                <Select
                                                                    options={categories}
                                                                    isMulti={false}
                                                                    onChange={handleChangeCategoryFilter}
                                                                    value={category_select_filter}
                                                                />

                                                            </li>
                                                        </>
                                                    }
                                                    {other_filter.visible_type &&
                                                        <>
                                                            <li className=" mr-2 mb-1">
                                                                <label className="form-label">Tipo</label>
                                                                <Select
                                                                    options={typeMaintenance}
                                                                    isMulti={false}
                                                                    onChange={handleChangeTypeFilter}
                                                                    value={type_select_filter}
                                                                />

                                                            </li>
                                                        </>
                                                    }
                                                </ul>
                                            </div>
                                            {/* sidebar label end */}
                                        </div>
                                    </div>
                                </div>
                                {/* User new mail right area */}
                                {

                                    permisos.filter(element => element.codigo === "add_maintenance").length > 0 ?
                                        <div className={`compose-new-mail-sidebar ${showSibarRight ? 'show' : ''}`}
                                             style={{
                                                 overflowY: 'scroll',
                                             }}
                                        >
                                            <div className="card shadow-none quill-wrapper p-0">
                                                <div className="card-header">
                                                    <h3 className="card-title" id="maintenancea">
                                                        Nuevo mantenimiento
                                                    </h3>
                                                    <button type="button" className="close close-icon"
                                                            onClick={() => {
                                                                setShowSibarRight(false);
                                                                setShowSibarLeft(false);
                                                                setShowOverlay(false);
                                                            }}
                                                    >
                                                        <i className="bx bx-x"/>
                                                    </button>
                                                </div>
                                                {/* form start */}
                                                <form onSubmit={handleSubmit} id="compose-form">
                                                    <div className="card-content">
                                                        <div className="card-body pt-0">
                                                            <label className="form-label">Establecimiento</label>
                                                            <Select
                                                                options={establishment}
                                                                isMulti={false}
                                                                onChange={handleChangeEstablishment}
                                                                value={establishment_select}
                                                            />
                                                            <br/>
                                                            <label className="form-label">Tipo de mantenimiento</label>
                                                            <Select
                                                                options={typeMaintenance}
                                                                isMulti={false}
                                                                onChange={handleChangeTypeMaintenance}
                                                                value={type_maintenance_select}
                                                            />
                                                            <br/>
                                                            <TextArea
                                                                id="descripcion"
                                                                name="descripcion"
                                                                label="Descripción"
                                                                placeholder=""
                                                                onChange={handleChange}
                                                                rows={4}
                                                                value={form.descripcion}
                                                            />
                                                            <br/>
                                                            <Input
                                                                label="Foto"
                                                                name="imagen"
                                                                type="file"
                                                                accept="image/*"
                                                                onChange={handleFileChange}
                                                            />
                                                            <br/>
                                                            <CheckBox label="¿Cuenta con presupuesto?"
                                                                      name="presupuesto" id="presupuesto"
                                                                      onChange={handleChangePresupuesto}
                                                                      state={form.presupuesto}/>
                                                            <br/>
                                                            {/*<Input*/}
                                                            {/*    label="Costo estimado del mantenimiento"*/}
                                                            {/*    name="valor_estimado"*/}
                                                            {/*    value={form.valor_estimado}*/}
                                                            {/*    onChange={handleChange}*/}
                                                            {/*    type="number"*/}
                                                            {/*    min="0"*/}
                                                            {/*    step="0.01"*/}
                                                            {/*/>*/}
                                                        </div>
                                                    </div>
                                                    <div className="card-footer d-flex justify-content-end pt-0">
                                                        <Button
                                                            text="Cancelar"
                                                            theme="light-secondary"
                                                            type="reset"
                                                            classes="cancel-btn mr-1"
                                                            onChange={() => {
                                                                setShowSibarRight(false);
                                                                setShowOverlay(!showOverlay);
                                                            }}
                                                        />
                                                        <Button
                                                            text="Guardar"
                                                            onChange={() => {
                                                                //TODO: AGREGAR FUNCIONALIDAD DE CREAR MAINTENANCE
                                                            }}
                                                            theme="success"
                                                            type="submit"
                                                            disabled={isLoading}
                                                        />
                                                    </div>
                                                </form>
                                                {/* form start end*/}
                                            </div>
                                        </div> : null}
                                {/*/ User Chat profile right area */}
                            </div>
                        </div>
                        <div className="content-right">
                            <div className="content-overlay"/>
                            <div className="content-wrapper">
                                <div className="content-header row"/>
                                <div className="content-body">
                                    {/* email app overlay */}
                                    <div className={`app-content-overlay ${showOverlay ? 'show' : ''}`}
                                         onClick={
                                             () => {
                                                 setShowSibarRight(!showSibarRight);
                                                 setShowSibarLeft(false);
                                                 setShowDetail(false);
                                                 setShowOverlay(!showOverlay);
                                             }
                                         }
                                    />
                                    <div className="email-app-area">
                                        {/* Email list Area */}
                                        <div className="email-app-list-wrapper">
                                            <div className="email-app-list">
                                                <div className="email-action">
                                                    <div
                                                        className="action-right d-flex flex-grow-1 align-items-center justify-content-around">
                                                        {/* search bar  */}
                                                        <div className="email-fixed-search flex-grow-1">
                                                            <div className="sidebar-toggle d-block d-lg-none" onClick={
                                                                () => {
                                                                    setShowSibarLeft(!showSibarLeft);
                                                                    setShowOverlay(!showOverlay);
                                                                }
                                                            }>
                                                                <i className="bx bx-menu"/>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-10">
                                                                    <Search placeholder={"Buscar por establecimiento o número de solicitud"} onChange={handleSearch}/>
                                                                </div>
                                                                { permisos && permisos.filter(x => x.codigo === 'generate_report_maintenance').length > 0 &&
                                                                    <div className="col-2">
                                                                        <Button
                                                                            text={<h3><i className="text-white bx bx-export"/></h3>}
                                                                            theme="success"
                                                                            type="button"
                                                                            classes="btn-lg round"
                                                                            onClick={handleGenerateReport}
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        {/* pagination and page count */}
                                                    </div>
                                                </div>
                                                {/* / action right */}

                                                {/* email user list start */}
                                                <div className="email-user-list list-group">
                                                    <ul className="users-list-wrapper media-list" style={{
                                                        overflowY: 'scroll',
                                                    }}>
                                                        <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={() => loadFunc()}
                                                            hasMore={HasMore}
                                                            useWindow={false}

                                                            loader={
                                                                <div className="col-12 d-flex justify-content-center">
                                                                    <div
                                                                        className="spinner-border text-success"
                                                                        role="status"
                                                                    >
                                                                        <span className="sr-only">Loading...</span>
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                            }
                                                        >
                                                            {datas.map((item, index) => (
                                                                <ItemList1
                                                                    item={item}
                                                                    title={item.establecimiento + ' (' + item.codigo_establecimiento + ')'}
                                                                    subtitle={item.secuencial}
                                                                    rightDescription={item.estado}
                                                                    bulletType={get_status(item.estado)}
                                                                    children={
                                                                        <>
                                                                            <div className="user-details div_fecha">
                                                                                <div className="mail-items">
                                                                                    <small>{item.descripcion}</small><br/>
                                                                                    <small>Fecha: {item.fecha_creacion}</small>
                                                                                </div>
                                                                                <div className="email-items">
                                                                                    <small>{"Tipo: " + item.tipo}</small>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                    onClick={onItemClickListener}
                                                                />
                                                            ))}
                                                        </InfiniteScroll>
                                                    </ul>
                                                    {/* email user list end */}

                                                    {/* no result when nothing to show on list */}
                                                    <div className="no-results">
                                                        <i className="bx bx-error-circle font-large-2"/>
                                                        <h5>No Items Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Email list Area */}
                                        {/* Detailed Email View */}
                                        <div className={`email-app-details ${showDetail ? 'show' : ''} `}>
                                            {/* email detail view header */}
                                            <div className="email-detail-header">
                                                <div className="email-header-left d-flex align-items-center mb-1">
                                                    <span className="go-back mr-50" onClick={
                                                        () => {
                                                            setShowDetail(false);
                                                        }
                                                    }>
                                                        <span className="fonticon-wrap d-inline">
                                                        <i className="bx bx-arrow-back"/>
                                                        </span>
                                                    </span>
                                                    <h5 className="email-detail-title font-weight-normal mb-0">
                                                        {DataSelected.secuencial}
                                                    </h5>
                                                </div>
                                                <div className="email-header-right mb-1 ml-2 pl-1">
                                                    <span
                                                        className={`badge badge-light-${get_status(DataSelected.estado)} badge-pill ml-1`}>
                                                        {DataSelected.estado}
                                                    </span>
                                                </div>
                                            </div>
                                            {/* email detail view header end*/}
                                            <div className="email-scroll-area" style={{overflowY: 'scroll',}}>
                                                {/* email details  */}
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="collapsible email-detail-head">
                                                            <Card
                                                                title={DataSelected.establecimiento + ' (' + DataSelected.codigo_establecimiento + ')'}
                                                            >
                                                                <div className="row">
                                                                    {(DataSelected.descripcion) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Descripción: </h6>{DataSelected.descripcion}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.fecha_creacion) &&
                                                                        <div className="col-md-6 col-12 mb-1">
                                                                            <h6>Fecha de creación: </h6>{DataSelected.fecha_creacion}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.fecha_mantenimiento) &&
                                                                        <div className="col-md-6 col-12 mb-1">
                                                                            <h6>Fecha de mantenimiento: </h6>{DataSelected.fecha_mantenimiento}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.fecha_aprobacion) &&
                                                                        <div className="col-md-6 col-12 mb-1">
                                                                            <h6>Fecha de aprobación: </h6>{DataSelected.fecha_aprobacion}
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className="row">
                                                                    {(DataSelected.proveedor) &&
                                                                        <div className="col-md-6 col-12 mb-1">
                                                                            <h6>Proveedor: </h6>{DataSelected.proveedor}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.tipo) &&
                                                                        <div className="col-md-6 col-12 mb-1">
                                                                            <h6>Tipo: </h6>{DataSelected.tipo}
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-6 col-12 mb-1">
                                                                        <h6>¿Cuenta con presupuesto?: </h6>{DataSelected.presupuesto ? 'SI' : 'NO'}
                                                                    </div>
                                                                    {/*{(DataSelected.valor_estimado) &&*/}
                                                                    {/*    <div className="col-md-6 col-12 mb-1">*/}
                                                                    {/*        <h6>Costo estimado: </h6>{DataSelected.valor_estimado}*/}
                                                                    {/*    </div>*/}
                                                                    {/*}*/}
                                                                    {(DataSelected.valor_inicial) &&
                                                                        <div className="col-md-6 col-12 mb-1">
                                                                            <h6>Costo inicial: </h6>{DataSelected.valor_inicial}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.valor) &&
                                                                        <div className="col-md-6 col-12 mb-1">
                                                                            <h6>Costo real: </h6>{DataSelected.valor}
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className="row">
                                                                    {(DataSelected.image) &&
                                                                        <div className="col-12 mb-1">
                                                                            {/*eslint-disable-next-line*/}
                                                                            <a href={`${URLAPI}${DataSelected.image}`} target="_blank" className="btn btn-info">
                                                                                Ver foto
                                                                            </a>
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.invoice) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Factura</h6>
                                                                            {/*eslint-disable-next-line*/}
                                                                            <a href={`${URLAPI}${DataSelected.invoice}`} target="_blank">
                                                                                <img
                                                                                    className="logo"
                                                                                    src="/base/app-assets/images/icon/pdf.png"
                                                                                    alt="logo"
                                                                                    style={{width: "100px",height: "auto", }}
                                                                                />
                                                                            </a>

                                                                        </div>
                                                                    }
                                                                    {(DataSelected.motivo) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Motivo: </h6>{DataSelected.motivo}
                                                                        </div>
                                                                    }
                                                                    <div className="col-12 div-flex mt-2 mb-5">
                                                                        {(permisos.filter(x => x.codigo === 'valid_maintenance').length > 0 && DataSelected.estado === "MANTENIMIENTO CREADO") &&
                                                                            <>
                                                                                <Button
                                                                                    text="Rechazar"
                                                                                    onChange={() => {
                                                                                        dispatch(getAllReasonMaintenance(token));
                                                                                        setIdReason(0);
                                                                                        document.getElementById("motivo").selectedIndex = 0;
                                                                                        setModalDecline(true);
                                                                                    }}
                                                                                    theme="danger"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                                <Button
                                                                                    text="Aceptar"
                                                                                    onChange={handleSubmitAccept}
                                                                                    theme="success"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                            </>
                                                                        }
                                                                        {(permisos.filter(x => x.codigo === 'approval_maintenance').length > 0 && DataSelected.estado === "MANTENIMIENTO ACEPTADO") &&
                                                                            <>
                                                                                <Button
                                                                                    text="Rechazar"
                                                                                    onChange={() => {
                                                                                        dispatch(getAllReasonMaintenance(token));
                                                                                        setIdReason(0);
                                                                                        document.getElementById("motivo").selectedIndex = 0;
                                                                                        setModalDecline(true);
                                                                                    }}
                                                                                    theme="danger"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                                <Button
                                                                                    text="Aprobar mantenimiento"
                                                                                    onChange={() => {
                                                                                        dispatch(getAllSuppliers(token));
                                                                                        setValueInitial(0);
                                                                                        setDateMaintenance('');
                                                                                        setIdSupplier(0);
                                                                                        document.getElementById("proveedor").selectedIndex = 0;
                                                                                        setModalAceptar(true);
                                                                                    }}
                                                                                    theme="success"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                            </>
                                                                        }
                                                                        {(permisos.filter(x => x.codigo === 'approval_maintenance').length > 0 && DataSelected.estado === "MANTENIMIENTO APROBADO") &&
                                                                            <Button
                                                                                text="Reagendar"
                                                                                onChange={() => {
                                                                                    setDateMaintenance(DataSelected.fecha_mantenimiento)
                                                                                    setModalReschedule(true);
                                                                                }}
                                                                                theme="warning"
                                                                                classes="button_div1"
                                                                                type="button"
                                                                                disabled={isLoading}
                                                                            />
                                                                        }
                                                                        {(permisos.filter(x => x.codigo === 'add_maintenance').length > 0 && DataSelected.estado === "MANTENIMIENTO APROBADO") &&
                                                                            <Button
                                                                                text="Mantenimiento Ejecutado"
                                                                                onChange={handleSubmitExecuted}
                                                                                theme="success"
                                                                                classes="button_div1"
                                                                                type="button"
                                                                                disabled={isLoading}
                                                                            />
                                                                        }
                                                                        {(permisos.filter(x => x.codigo === 'approval_maintenance').length > 0 && DataSelected.estado === "MANTENIMIENTO EJECUTADO") &&
                                                                            <Button
                                                                                text="Validar"
                                                                                onChange={() => {
                                                                                    setValue(0);
                                                                                    setInvoice('');
                                                                                    setModalValidar(true);
                                                                                }}
                                                                                theme="success"
                                                                                classes="button_div1"
                                                                                type="button"
                                                                                disabled={isLoading}
                                                                            />
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* email details  end*/}
                                                <div className="row px-2 mb-4">
                                                    {/* quill editor for reply message */}
                                                    <div className="col-12 px-0"/>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Detailed Email View */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal1" show={modalAceptar}>
                <form onSubmit={handleSubmitApproval}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Aceptar</h5>
                        <div className="form-group">
                            <Input
                                label="Costo inicial del mantenimiento"
                                name="valor_inicial"
                                value={valueInitial}
                                onChange={(e) => setValueInitial(e.target.value)}
                                type="number"
                                min="0"
                                step="0.01"
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Fecha del mantenimiento"
                                name="dateMaintenance"
                                value={dateMaintenance}
                                onChange={(e) => setDateMaintenance(e.target.value)}
                                type="datetime-local"
                            />
                        </div>
                        <div className="form-group">
                            <label>Proveedor</label>
                            <SelectInput
                                id="proveedor"
                                label="Proveedor"
                                name="idSupplier"
                                onChange={(e) => setIdSupplier(parseInt(e.target.value))}
                                options={suppliers ? suppliers.map((item) => ({
                                    name: item.nombre,
                                    id: item.id,
                                })) : []}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Aceptar
                        </button>
                        <button type="button" onClick={() => {
                            setModalAceptar(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalValidar}>
                <form onSubmit={handleUpdateSubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Validar</h5>
                        <div className="form-group">
                            <Input
                                label="Costo real del mantenimiento"
                                name="valor"
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                                type="number"
                                min="0"
                                step="0.01"
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Factura"
                                name="archivo"
                                type="file"
                                accept=".docx,.pdf"
                                onChange={(e) => setInvoice(e.target.files[0])}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Validar
                        </button>
                        <button type="button" onClick={() => {
                            setModalValidar(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalDecline}>
                <form onSubmit={handleDeclineSubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Rechazar</h5>
                        <div className="form-group">
                            <label>Motivo</label>
                            <SelectInput
                                id="motivo"
                                label="motivo"
                                name="idReason"
                                onChange={(e) => setIdReason(parseInt(e.target.value))}
                                options={reasonMaintenance ? reasonMaintenance.map((item) => ({
                                    name: item.descripcion,
                                    id: item.id,
                                })) : []}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Aceptar
                        </button>
                        <button type="button" onClick={() => {
                            setModalDecline(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalReschedule}>
                <form onSubmit={handleRescheduleSubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Reagendar</h5>
                        <div className="form-group">
                            <Input
                                label="Fecha del mantenimiento"
                                name="dateMaintenance"
                                value={dateMaintenance}
                                onChange={(e) => setDateMaintenance(e.target.value)}
                                type="datetime-local"
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Aceptar
                        </button>
                        <button type="button" onClick={() => {
                            setModalReschedule(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalSurvey}>
                <form onSubmit={handleSurveySubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Encuesta de Satisfacción</h5>
                        {surveys.length > 0 &&
                            surveys.map((item, index) => (
                                <div className="form-group">
                                    <label>{item.pregunta}</label>
                                    <SelectInput
                                        label="Opciones"
                                        id={"opcion-" + item.id}
                                        name={item.id}
                                        onChange={handleChangeOptions}
                                        options={item.opciones ? item.opciones.map((op) => ({
                                            name: op.opcion,
                                            id: op.id,
                                        })) : []}
                                    />
                                </div>
                            ))
                        }
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div mt-1`}>Guardar
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default MaintenanceAdmin;
